import React from 'react'
import styled from 'styled-components'
import { Link as GatsbyLink } from 'gatsby'
import { Row } from './layout'
import Svg from './svg'
import NavigationBar from './navigation-bar'
import { onTablet, onMobile } from '../utils/selector'

interface Props {
  compact?: boolean
}

export default function Header({ compact = false }: Props) {
  return (
    <Responsive>
      <Container
        className={`${compact ? 'compact' : ''}`}
        alignment="space-between"
        crossAlignment="center"
      >
        <GatsbyLink to="/">
          <Logo name="logo" />
        </GatsbyLink>
        <Row gutter={48}>
          <a href="/cn">主页</a>
          <GatsbyLink to="/package">报价</GatsbyLink>
          <a href="https://blog.corplaw.ai">官博</a>
        </Row>
      </Container>

      <NavigationBar />
    </Responsive>
  )
}

const Responsive = styled.div`
  ${onTablet} {
    > *:last-child {
      display: none;
    }
  }

  ${onMobile} {
    > *:first-child {
      display: none;
    }
  }
`

const Container = styled(Row)`
  padding: 48px 64px;

  &.compact {
    padding: 32px 42px 12px;
  }

  a {
    font-size: 14px;
    line-height: 20px;
    color: #364d6e;
    text-decoration: none;
  }
`

const Logo = styled(Svg)`
  width: 230px;
  height: 92px;

  .compact & {
    width: 185px;
    height: 74px;
  }
`
